export function initProduct(scope = document) {
  const sections = scope.querySelectorAll('[data-product-section]');
  if (!sections.length) return;

  sections.forEach((root) => {
    if (root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';

    const sid = root.dataset.sectionId;
    const moneyFormat = root.dataset.moneyFormat;
    const VARIANTS = JSON.parse(root.dataset.variants || '[]');

    function formatMoney(cents) {
      const isFrench = (document.documentElement.lang || window.Shopify?.locale || '').toLowerCase().startsWith('fr');
      let formatted = '';
      try {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          formatted = Shopify.formatMoney(cents, moneyFormat);
        }
      } catch (_) {}

      if (!formatted) {
        const value = (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
        formatted = '€' + value;
      }

      if (isFrench) {
        const clean = formatted.replace('€', '').trim().replace(',-', ',00').replace('.-', ',00');
        return `${clean} €`;
      }

      return formatted.replace(',00', ',-').replace('.00', ',-');
    }

    const thumbsWrap = root.querySelector('#Thumbs-' + sid);
    const mainMediaContainer = root.querySelector('[data-main-media-container]');
    const mainMediaItems = mainMediaContainer ? mainMediaContainer.querySelectorAll('.main-media-item') : [];
    const modal = document.getElementById('pm-modal-' + sid);
    const modalMedia = document.getElementById('pm-media-' + sid);
    const modalImg = document.getElementById('pm-img-' + sid);

    if (modal) {
      document.body.appendChild(modal);
    }

    const images = [];

    if (thumbsWrap) {
      thumbsWrap.querySelectorAll('.thumb').forEach((btn) => {
        images.push({
          url: btn.getAttribute('data-large'),
          id: btn.getAttribute('data-media-id')
        });
      });
    }

    function getActiveIndex() {
      let activeIndex = 0;
      mainMediaItems.forEach((item, index) => {
        if (item.classList.contains('is-active')) {
          activeIndex = index;
        }
      });
      return activeIndex;
    }

    function scrollActiveThumbIntoView(activeThumb) {
      if (!thumbsWrap || !activeThumb) return;

      const containerRect = thumbsWrap.getBoundingClientRect();
      const thumbRect = activeThumb.getBoundingClientRect();

      const isVertical = window.innerWidth > 991;

      if (isVertical) {
        const currentScrollTop = thumbsWrap.scrollTop;
        const offset = thumbRect.top - containerRect.top;
        const targetScrollTop = currentScrollTop + offset - (containerRect.height / 2) + (thumbRect.height / 2);

        thumbsWrap.scrollTo({
          top: targetScrollTop,
          behavior: 'smooth'
        });
      } else {
        const currentScrollLeft = thumbsWrap.scrollLeft;
        const offset = thumbRect.left - containerRect.left;
        const targetScrollLeft = currentScrollLeft + offset - (containerRect.width / 2) + (thumbRect.width / 2);

        thumbsWrap.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth'
        });
      }
    }

    function showMedia(index) {
      if (!mainMediaItems.length) return;
      const safeIndex = (index + mainMediaItems.length) % mainMediaItems.length;

      mainMediaItems.forEach((item, idx) => {
        const isCurrent = idx === safeIndex;
        item.classList.toggle('is-active', isCurrent);

        // Control HTML5 videos
        const video = item.querySelector('video');
        if (video) {
          if (isCurrent) {
            video.currentTime = 0;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      });

      setActiveThumbByIndex(safeIndex);

      const activeThumb = thumbsWrap?.querySelector('.thumb[data-index="' + safeIndex + '"]');
      scrollActiveThumbIntoView(activeThumb);
    }

    function setActiveThumbByIndex(index) {
      if (!thumbsWrap) return;

      thumbsWrap.querySelectorAll('.thumb').forEach((button) => {
        button.classList.toggle('is-active', String(button.dataset.index) === String(index));
      });
    }

    function setActiveThumbByMediaId(mediaId) {
      if (!thumbsWrap || !mediaId) return;

      const button = thumbsWrap.querySelector('.thumb[data-media-id="' + mediaId + '"]');

      if (!button) return;

      const index = parseInt(button.getAttribute('data-index'), 10);
      showMedia(index);
    }

    if (thumbsWrap && mainMediaItems.length) {
      thumbsWrap.addEventListener('click', function (event) {
        const button = event.target.closest('.thumb');

        if (!button) return;

        const index = parseInt(button.dataset.index, 10);
        showMedia(index);
      });
    }

    const galleryPrev = root.querySelector('[data-gallery-prev]');
    const galleryNext = root.querySelector('[data-gallery-next]');
    const mainMediaPrev = root.querySelector('[data-main-media-prev]');
    const mainMediaNext = root.querySelector('[data-main-media-next]');

    function changeMainImageByDirection(direction) {
      if (!mainMediaItems.length) return;

      const current = getActiveIndex();
      const next = current + direction;

      showMedia(next);
    }

    if (galleryPrev) {
      galleryPrev.addEventListener('click', function () {
        changeMainImageByDirection(-1);
      });
    }

    if (galleryNext) {
      galleryNext.addEventListener('click', function () {
        changeMainImageByDirection(1);
      });
    }

    if (mainMediaPrev) {
      mainMediaPrev.addEventListener('click', function () {
        changeMainImageByDirection(-1);
      });
    }

    if (mainMediaNext) {
      mainMediaNext.addEventListener('click', function () {
        changeMainImageByDirection(1);
      });
    }

    const openBtn = root.querySelector('[data-open-modal]');

    function clearModalVideo() {
      if (!modalMedia) return;

      modalMedia.querySelectorAll('.pm-video, .pm-external-video').forEach((media) => {
        if (media.tagName === 'VIDEO') media.pause();
        media.remove();
      });
    }

    function setModalMedia(index) {
      if (!modalImg || !modalMedia) return;

      clearModalVideo();

      const mediaItem = mainMediaItems[index];
      const sourceVideo = mediaItem?.querySelector('video');
      const sourceIframe = mediaItem?.querySelector('iframe');

      if (sourceVideo) {
        const video = sourceVideo.cloneNode(true);
        video.removeAttribute('id');
        video.className = 'pm-video';
        video.controls = true;
        video.autoplay = true;
        video.loop = true;
        video.muted = true;
        video.playsInline = true;
        modalImg.hidden = true;
        modalMedia.appendChild(video);
        sourceVideo.pause();
        video.play().catch(() => {});
        modalImg.dataset.idx = String(index);
        return;
      }

      if (sourceIframe) {
        const iframe = sourceIframe.cloneNode(true);
        iframe.removeAttribute('id');
        iframe.className = 'pm-external-video';
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        modalImg.hidden = true;
        modalMedia.appendChild(iframe);
        modalImg.dataset.idx = String(index);
        return;
      }

      const mediaImage = mediaItem?.querySelector('img');
      const thumbImage = thumbsWrap?.querySelector('.thumb[data-index="' + index + '"] img');
      const sourceImage = mediaImage || thumbImage;
      const url = sourceImage?.dataset.itTranslatedSrc || sourceImage?.currentSrc || sourceImage?.src || images[index]?.url || '';

      // Image translators keep the original/translated pair on the modal image.
      // If that stale state survives a gallery step, their observer restores the
      // previous translated image and the modal appears to be stuck.
      modalImg.classList.remove('it-swapped', 'it-ready');
      modalImg.removeAttribute('data-it-original-src');
      modalImg.removeAttribute('data-it-translated-src');
      modalImg.src = url;
      modalImg.alt = sourceImage?.alt || '';
      modalImg.dataset.idx = String(index);
      modalImg.hidden = false;
    }

    function openModal(index) {
      if (!modal || !modalImg) return;

      const safeIndex = Math.max(0, Math.min(images.length - 1, parseInt(index || 0, 10)));

      modal.setAttribute('aria-hidden', 'false');
      setModalMedia(safeIndex);
      document.documentElement.classList.add('pm-no-scroll');
      document.body.classList.add('pm-no-scroll');
    }

    function closeModal() {
      if (!modal || !modalImg) return;

      modal.setAttribute('aria-hidden', 'true');
      clearModalVideo();
      modalImg.removeAttribute('src');
      modalImg.hidden = false;
      document.documentElement.classList.remove('pm-no-scroll');
      document.body.classList.remove('pm-no-scroll');
    }

    function stepModal(direction) {
      if (!modalImg || !images.length) return;

      const current = parseInt(modalImg.dataset.idx || '0', 10);
      const next = (current + direction + images.length) % images.length;

      setModalMedia(next);

      showMedia(next);
    }

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        openModal(getActiveIndex());
      });
    }

    let hasDragged = false;

    if (mainMediaContainer && mainMediaItems.length > 1) {
      let startX = 0;
      let startY = 0;
      let isDragging = false;
      let dragThreshold = 50; // minimum pixels to count as a swipe

      const getEventX = (e) => {
        return e.touches ? e.touches[0].clientX : e.clientX;
      };

      const getEventY = (e) => {
        return e.touches ? e.touches[0].clientY : e.clientY;
      };

      const onStart = (e) => {
        if (e.type === 'mousedown' && e.button !== 0) return;
        if (e.target.closest('video') || e.target.closest('iframe')) return;

        startX = getEventX(e);
        startY = getEventY(e);
        isDragging = true;
        hasDragged = false;
      };

      const onMove = (e) => {
        if (!isDragging) return;

        const currentX = getEventX(e);
        const currentY = getEventY(e);

        const diffX = currentX - startX;
        const diffY = currentY - startY;

        if (Math.abs(diffX) > 10 || Math.abs(diffY) > 10) {
          hasDragged = true;
        }

        if (Math.abs(diffX) > Math.abs(diffY)) {
          if (e.cancelable) {
            e.preventDefault();
          }
        }
      };

      const onEnd = (e) => {
        if (!isDragging) return;
        isDragging = false;

        const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        const endY = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;

        const diffX = endX - startX;
        const diffY = endY - startY;

        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > dragThreshold) {
          if (diffX > 0) {
            changeMainImageByDirection(-1);
          } else {
            changeMainImageByDirection(1);
          }
        }
      };

      mainMediaContainer.addEventListener('mousedown', onStart, { passive: true });
      mainMediaContainer.addEventListener('touchstart', onStart, { passive: true });
      mainMediaContainer.addEventListener('mousemove', onMove, { passive: true });
      mainMediaContainer.addEventListener('touchmove', onMove, { passive: false });
      mainMediaContainer.addEventListener('mouseup', onEnd, { passive: true });
      mainMediaContainer.addEventListener('touchend', onEnd, { passive: true });
      mainMediaContainer.addEventListener('mouseleave', onEnd, { passive: true });

      mainMediaContainer.addEventListener('dragstart', (e) => {
        e.preventDefault();
      });
    }

    if (mainMediaContainer) {
      mainMediaContainer.addEventListener('click', (e) => {
        if (hasDragged) {
          hasDragged = false;
          return;
        }

        const btn = e.target.closest('[data-open-modal]');
        if (btn) {
          const item = btn.closest('.main-media-item');
          if (item) {
            const index = parseInt(item.dataset.index, 10);
            openModal(index);
          }
        }
      });
    }

    if (modal) {
      let modalStartX = 0;
      let modalStartY = 0;
      let modalIsDragging = false;
      let modalHasDragged = false;
      const modalDragThreshold = 50;

      const getModalEventX = (e) => {
        return e.touches ? e.touches[0].clientX : e.clientX;
      };

      const getModalEventY = (e) => {
        return e.touches ? e.touches[0].clientY : e.clientY;
      };

      const onModalStart = (e) => {
        if (e.type === 'mousedown' && e.button !== 0) return;
        if (e.target.closest('.pm-close') || e.target.closest('.pm-prev') || e.target.closest('.pm-next')) return;
        if (e.target.closest('video') || e.target.closest('iframe')) return;

        modalStartX = getModalEventX(e);
        modalStartY = getModalEventY(e);
        modalIsDragging = true;
        modalHasDragged = false;
      };

      const onModalMove = (e) => {
        if (!modalIsDragging) return;

        const currentX = getModalEventX(e);
        const currentY = getModalEventY(e);

        const diffX = currentX - modalStartX;
        const diffY = currentY - modalStartY;

        if (Math.abs(diffX) > 10 || Math.abs(diffY) > 10) {
          modalHasDragged = true;
        }

        if (Math.abs(diffX) > Math.abs(diffY)) {
          if (e.cancelable) {
            e.preventDefault();
          }
        }
      };

      const onModalEnd = (e) => {
        if (!modalIsDragging) return;
        modalIsDragging = false;

        const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        const endY = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;

        const diffX = endX - modalStartX;
        const diffY = endY - modalStartY;

        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > modalDragThreshold) {
          if (diffX > 0) {
            stepModal(-1);
          } else {
            stepModal(1);
          }
        }
      };

      modal.addEventListener('mousedown', onModalStart, { passive: true });
      modal.addEventListener('touchstart', onModalStart, { passive: true });
      modal.addEventListener('mousemove', onModalMove, { passive: true });
      modal.addEventListener('touchmove', onModalMove, { passive: false });
      modal.addEventListener('mouseup', onModalEnd, { passive: true });
      modal.addEventListener('touchend', onModalEnd, { passive: true });
      modal.addEventListener('mouseleave', onModalEnd, { passive: true });

      modal.addEventListener('dragstart', (e) => {
        e.preventDefault();
      });

      modal.addEventListener('click', function (event) {
        if (modalHasDragged) {
          modalHasDragged = false;
          return;
        }

        if (event.target.dataset.close !== undefined || event.target.classList.contains('pm-backdrop')) {
          closeModal();
        }

        if (event.target.classList.contains('pm-prev')) {
          stepModal(-1);
        }

        if (event.target.classList.contains('pm-next')) {
          stepModal(1);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (modal.getAttribute('aria-hidden') === 'true') return;

        if (event.key === 'Escape') closeModal();
        if (event.key === 'ArrowRight') stepModal(1);
        if (event.key === 'ArrowLeft') stepModal(-1);
      });
    }

    const form = document.getElementById('ProductForm-' + sid);

    if (!form) return;

    function getVariantById(variantId) {
      return VARIANTS.find((variant) => String(variant.id) === String(variantId));
    }

    function updatePrice(variant) {
      const priceBox = root.querySelector('[data-price-box]');
      const priceExclBox = root.querySelector('[data-price-excl-box]');
      const klarnaPlacements = root.querySelectorAll('klarna-placement');

      if (!variant) return;

      if (priceBox) {
        let html = '<span>' + formatMoney(variant.price) + '</span>';

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const discount = variant.compare_at_price - variant.price;

          html += ' <del>' + formatMoney(variant.compare_at_price) + '</del>';
          html += ' <strong>' + (root.dataset.labelSave || 'Bespaar') + ' ' + formatMoney(discount) + '</strong>';
        }

        priceBox.innerHTML = html;
      }

      if (priceExclBox) {
        const priceExcl = Math.round(variant.price / 1.21);
        priceExclBox.innerHTML = '<span>' + formatMoney(priceExcl) + ' ' + (root.dataset.labelExclVat || 'excl. BTW') + '</span>';
      }

      if (klarnaPlacements.length > 0) {
        klarnaPlacements.forEach((placement) => {
          placement.setAttribute('data-purchase-amount', variant.price);
        });
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
      }
    }

    function updateStock(variant) {
      const stock = root.querySelector('[data-stock-status]');

      if (!stock || !variant) return;

      const isLow = variant.available && 
                    variant.inventory_management && 
                    variant.inventory_quantity > 0 && 
                    variant.inventory_quantity < 10;

      const backorderMsg = variant.backorder_message || stock.dataset.backorderMessage;
      const isBackorder = variant.available &&
                          variant.inventory_management &&
                          variant.inventory_quantity <= 0 &&
                          backorderMsg;

      if (isBackorder) {
        stock.classList.remove('is-out', 'is-low');
        stock.classList.add('is-backorder');
        stock.innerHTML = `
          <span class="product-info__stock-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="8" fill="#F2994A"/>
              <path d="M13 5L7.16216 10L4.5 7.71991" stroke="white" stroke-width="1.5"/>
            </svg>
          </span>
          <span>${backorderMsg}</span>
        `;
      } else if (isLow) {
        stock.classList.remove('is-out', 'is-backorder');
        stock.classList.add('is-low');
        stock.innerHTML = `
          <span class="product-info__stock-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="8" fill="#ff1f1f"/>
              <path d="M13 5L7.16216 10L4.5 7.71991" stroke="white" stroke-width="1.5"/>
            </svg>
          </span>
          <span>${root.dataset.labelLowStockPrefix || 'Nog maar'} ${variant.inventory_quantity} ${root.dataset.labelLowStockSuffix || 'op voorraad'}</span>
        `;
      } else if (variant.available) {
        stock.classList.remove('is-out', 'is-low', 'is-backorder');
        stock.innerHTML = `
          <span class="product-info__stock-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="8" fill="#219653"/>
              <path d="M13 5L7.16216 10L4.5 7.71991" stroke="white" stroke-width="1.5"/>
            </svg>
          </span>
          <span>${root.dataset.labelInStock || 'Op voorraad, direct leverbaar'}</span>
        `;
      } else {
        stock.classList.remove('is-low', 'is-backorder');
        stock.classList.add('is-out');
        stock.innerHTML = `
          <span class="product-info__stock-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_16795_10468_js)">
                <circle cx="12" cy="12" r="12" fill="#ff1f1f"></circle>
                <path d="M7.5 7.5L16.5 16.5" stroke="#ffffff" stroke-width="1.5"></path>
                <path d="M16.5 7.5L7.5 16.5" stroke="#ffffff" stroke-width="1.5"></path>
              </g>
              <defs>
                <clipPath id="clip0_16795_10468_js">
                  <rect width="24" height="24" fill="white"></rect>
                </clipPath>
              </defs>
            </svg>
          </span>
          <span>${root.dataset.labelOutOfStock || 'Niet op voorraad'}</span>
        `;
      }
    }

    function updateVariantCards(variantId) {
      const cards = root.querySelectorAll('[data-variant-card]');

      cards.forEach((card) => {
        const isActive = String(card.dataset.variantId) === String(variantId);
        const small = card.querySelector('small');

        card.classList.toggle('is-active', isActive);

        if (small) {
          small.textContent = isActive ? (root.dataset.labelSelected || 'Geselecteerd') : (root.dataset.labelSelect || 'Selecteer');
        }
      });
    }

    function updateVariant(variantId) {
      const variant = getVariantById(variantId);

      if (!variant) return;

      const hiddenInput = form.querySelector('input[name="id"]');
      const addButton = form.querySelector('[data-atc]');
      const mediaId = variant.featured_media?.id || variant.featured_image?.id;

      if (hiddenInput) {
        hiddenInput.value = variant.id;
      }

      if (addButton) {
        addButton.toggleAttribute('disabled', !variant.available);
      }

      updatePrice(variant);
      updateStock(variant);
      updateVariantCards(variant.id);

      if (mediaId) {
        setActiveThumbByMediaId(String(mediaId));
      }

      const stickyBar = document.getElementById('sticky-cart-bar');
      if (stickyBar) {
        const stickySelect = stickyBar.querySelector('.sticky-cart-bar__select');
        const stickyAtcBtn = stickyBar.querySelector('.sticky-cart-bar__atc');
        const stickyPriceBox = stickyBar.querySelector('[data-price-box]');

        if (stickySelect) {
          stickySelect.value = variant.id;
        }
        if (stickyAtcBtn) {
          stickyAtcBtn.toggleAttribute('disabled', !variant.available);
        }
        if (stickyPriceBox) {
          let priceHtml = '<span>' + formatMoney(variant.price) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceHtml += ' <del class="text-muted" style="font-size: 14px; margin-left: 6px;">' + formatMoney(variant.compare_at_price) + '</del>';
          }
          stickyPriceBox.innerHTML = priceHtml;
        }
      }
    }

    root.querySelectorAll('[data-variant-card]').forEach((card) => {
      card.addEventListener('click', function (e) {
        if (card.classList.contains('is-active') || card.classList.contains('is-disabled') || card.disabled) {
          e.preventDefault();
          return;
        }
      });
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      const addButton = form.querySelector('[data-atc]');
      if (addButton) {
        addButton.disabled = true;
        addButton.classList.add('is-loading');
      }

      const formData = new FormData(form);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: formData
        });

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        const btn = document.querySelector('#js-open-mini-cart, [data-open-mini-cart]');
        if (btn) {
          btn.click();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } catch (error) {
        console.error(error);
        form.submit();
      } finally {
        if (addButton) {
          addButton.disabled = false;
          addButton.classList.remove('is-loading');
        }
      }
    });

    root.querySelectorAll('[data-copy-product-url]').forEach((button) => {
      button.addEventListener('click', async function () {
        const url = button.getAttribute('data-copy-product-url');

        if (!url) return;

        try {
          await navigator.clipboard.writeText(url);

          button.classList.add('is-copied');
          button.setAttribute('aria-label', 'Link copied');

          setTimeout(() => {
            button.classList.remove('is-copied');
            button.setAttribute('aria-label', 'Copy product link');
          }, 1600);
        } catch (error) {
          window.prompt('Copy this link:', url);
        }
      });
    });

    (function() {
      const stickyBar = document.getElementById('sticky-cart-bar');
      if (!stickyBar) return;

      document.body.appendChild(stickyBar);
      stickyBar.style.display = '';

      const mainAtcBtn = form.querySelector('[data-atc]');
      const stickyAtcBtn = stickyBar.querySelector('.sticky-cart-bar__atc');
      const stickySelect = stickyBar.querySelector('.sticky-cart-bar__select');
      let footer = null;

      const onScroll = () => {
        if (!mainAtcBtn) return;
        const rect = mainAtcBtn.getBoundingClientRect();
        
        if (!footer) {
          footer = document.querySelector('footer') || document.querySelector('.site-footer');
        }

        let footerVisible = false;
        if (footer) {
          const footerRect = footer.getBoundingClientRect();
          if (footerRect.top < window.innerHeight + 80) {
            footerVisible = true;
          }
        }

        if (rect.top < 0 && !footerVisible) {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        } else {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      if (stickyAtcBtn && mainAtcBtn) {
        stickyAtcBtn.addEventListener('click', (e) => {
          e.preventDefault();
          mainAtcBtn.click();
        });
      }

      if (stickySelect) {
        stickySelect.addEventListener('change', () => {
          const selectedVal = stickySelect.value;
          const matchingCard = root.querySelector(`[data-variant-card][data-variant-id="${selectedVal}"]`);
          if (matchingCard) {
            matchingCard.click();
          } else {
            updateVariant(selectedVal);
          }
        });
      }
    })();
  });
}
